import React, { ReactElement } from 'react';
import Panel from '../../../shared/components/card/Panel';
import { ReactComponent as PDFFileIcon } from '../../../assets/images/svg/i_excel_file.svg';
import { Col, Row } from 'antd';
import { authFeatureConstants, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { Button, Modal } from 'antd';
import './ReconciliationTATReport.less';
import { canActivate } from '../../../utils/utility';

export const ReconciliationReportList = (props: any): ReactElement => {
  const {  isModalOpen, closeModal } = props;
  const data =
    canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)
    ? [
      { label: 'Reconciliation Report_123', name: 'Reconciliation_Template_Group_admin.csv', time: 'January 27, 2022' },
    ] : [
        { label: 'Reconciliation Report_123', name: 'Reconciliation_Template.csv', time: 'January 27, 2022' },
    ];

  const onDownloadExcel = (fileName: string): any => {
    const linkSource = `${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}${fileName}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  };

  return (
    <Modal
      visible={isModalOpen}
      onCancel={closeModal}
      closable={false}
      maskClosable={false}
      className="upload-excel-model"
      footer={[
        <div className="text-center" key="agree">
          <Button danger={true} data-testid="agree"  className="w-100"
            onClick={(e: any): void => closeModal()}>
            Cancel
          </Button>
        </div>,
      ]}
  >
      <Panel
        title={<p  className="modal-heading">Download Template</p>}
        className="report-list"
      >
        <h2 className="modal-info">Please click and download</h2>
        {data && data.length > 0 && data.map((file: any, fileIndex: number): ReactElement => (
          <Row
            gutter={GUTTOR_SPACE}
            key={fileIndex}
            onClick={(e: any): void => onDownloadExcel(file.name)}
          >
            <Col md={6} className="file-icon-wrapper">
              <PDFFileIcon />
            </Col>
            <Col md={18} className="file-data">
              <p className="title mouse-pointer">{file.label}</p>
              <p className="time mouse-pointer">{file.time}</p>
            </Col>
          </Row>
        ))}
      </Panel>
    </Modal>
  );
};
